/* ==========================================================================
   Filament365 — product.js
   - <product-info>   : varyant seçimi (fiyat, stok, görsel, URL, seçilebilir kombinasyonlar),
                         Sepete Ekle / Hemen Satın Al, mobil sabit satın alma çubuğu
   - <product-gallery>: kaydırmalı galeri, küçük görseller, lightbox
   - <quick-view-modal>: hızlı ürün inceleme (varyant seçtirerek ekleme)
   - <product-recommendations>, <recently-viewed>
   ========================================================================== */
(function () {
  'use strict';

  var S = window.themeStrings || {};
  var T = window.themeSettings || { routes: {} };
  var F = window.F365;

  /* ======================================================================
     Galeri
     ====================================================================== */

  class ProductGallery extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.track = this.querySelector('[data-gallery-track]');
      if (!this.track) return;
      this.slides = Array.prototype.slice.call(this.track.querySelectorAll('.gallery__slide'));
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-thumb]'));
      this.counter = this.querySelector('[data-gallery-counter]');
      this.lightbox = this.querySelector('[data-lightbox]');
      this.index = 0;

      var ticking = false;
      this.track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var w = self.track.clientWidth || 1;
          self.setActive(Math.round(self.track.scrollLeft / w));
          ticking = false;
        });
      }, { passive: true });

      this.thumbs.forEach(function (t) {
        t.addEventListener('click', function () { self.goTo(parseInt(t.dataset.index, 10)); });
      });

      var prev = this.querySelector('[data-gallery-prev]');
      var next = this.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', function () { self.goTo(self.index - 1); });
      if (next) next.addEventListener('click', function () { self.goTo(self.index + 1); });

      this.track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); self.goTo(self.index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); self.goTo(self.index - 1); }
      });

      if (this.lightbox) this.initLightbox();
    }

    goTo(i, instant) {
      var n = this.slides.length;
      if (!n) return;
      i = Math.max(0, Math.min(n - 1, i));
      var slide = this.slides[i];
      this.track.scrollTo({ left: slide.offsetLeft, behavior: (instant || F.reducedMotion) ? 'auto' : 'smooth' });
      this.setActive(i);
    }

    setActive(i) {
      var n = this.slides.length;
      if (!n) return;
      i = Math.max(0, Math.min(n - 1, i));
      this.index = i;
      this.thumbs.forEach(function (t, idx) {
        var on = idx === i;
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      if (this.counter) this.counter.textContent = (i + 1) + ' / ' + n;
      var activeThumb = this.thumbs[i];
      var strip = this.querySelector('[data-gallery-thumbs]');
      if (activeThumb && strip) {
        var left = activeThumb.offsetLeft - strip.clientWidth / 2 + activeThumb.clientWidth / 2;
        var top = activeThumb.offsetTop - strip.clientHeight / 2 + activeThumb.clientHeight / 2;
        strip.scrollTo({ left: left, top: top, behavior: 'auto' });
      }
    }

    selectMedia(mediaId, instant) {
      if (!mediaId) return;
      for (var i = 0; i < this.slides.length; i++) {
        if (String(this.slides[i].dataset.mediaId) === String(mediaId)) {
          this.goTo(i, instant);
          return;
        }
      }
    }

    initLightbox() {
      var self = this;
      var dlg = this.lightbox;
      var img = dlg.querySelector('[data-lightbox-img]');
      var zoomables = this.slides.map(function (s, idx) {
        var btn = s.querySelector('[data-zoom-open]');
        return btn ? { idx: idx, src: btn.dataset.zoomSrc, alt: btn.dataset.zoomAlt } : null;
      }).filter(Boolean);
      var pos = 0;

      function show(p) {
        if (!zoomables.length) return;
        pos = (p + zoomables.length) % zoomables.length;
        img.src = zoomables[pos].src;
        img.alt = zoomables[pos].alt || '';
        self.goTo(zoomables[pos].idx, true);
      }

      this.addEventListener('click', function (e) {
        var open = e.target.closest('[data-zoom-open]');
        if (!open) return;
        var idx = self.slides.indexOf(open.closest('.gallery__slide'));
        for (var k = 0; k < zoomables.length; k++) if (zoomables[k].idx === idx) pos = k;
        show(pos);
        if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
        F.lockScroll();
      });

      dlg.addEventListener('close', function () { F.unlockScroll(); });
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg || e.target.closest('[data-lightbox-close]')) dlg.close();
        if (e.target.closest('[data-lightbox-prev]')) show(pos - 1);
        if (e.target.closest('[data-lightbox-next]')) show(pos + 1);
      });
      dlg.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') show(pos + 1);
        if (e.key === 'ArrowLeft') show(pos - 1);
      });
    }
  }
  customElements.define('product-gallery', ProductGallery);

  /* ======================================================================
     Ürün bilgisi / varyant mantığı
     ====================================================================== */

  class ProductInfo extends HTMLElement {
    connectedCallback() {
      var self = this;
      var jsonEl = this.querySelector('[data-product-json]');
      if (!jsonEl) return;
      try { this.data = JSON.parse(jsonEl.textContent); } catch (e) { return; }

      this.variants = this.data.variants || [];
      this.form = this.querySelector('form[data-product-form]');
      this.idInput = this.querySelector('[data-variant-id-input]');
      this.gallery = this.querySelector('product-gallery');
      this.addBtn = this.querySelector('[data-add-submit]');
      this.buyNowBtn = this.querySelector('[data-buy-now]');
      this.sticky = this.querySelector('[data-sticky-atc]');
      this.stickyBtn = this.querySelector('[data-sticky-submit]');
      this.qtyInput = this.querySelector('[data-pdp-qty]');
      this.updateUrl = this.dataset.updateUrl === 'true';

      var current = this.findById(this.idInput && parseInt(this.idInput.value, 10)) || this.variants[0];
      this.currentVariant = current;

      this.addEventListener('change', function (e) {
        if (e.target.matches('[data-option-input]')) self.onOptionChange();
      });

      if (this.form) {
        this.form.addEventListener('submit', function (e) {
          // Shopify hızlı ödeme düğmeleri kendi akışını yürütür
          if (e.submitter && e.submitter.name === 'checkout') return;
          e.preventDefault();
          self.addToCart(false);
        });
      }
      if (this.buyNowBtn) this.buyNowBtn.addEventListener('click', function () { self.addToCart(true); });
      if (this.stickyBtn) this.stickyBtn.addEventListener('click', function () { self.addToCart(false); });

      if (this.qtyInput) {
        this.qtyInput.addEventListener('change', function () {
          var v = parseInt(self.qtyInput.value, 10);
          if (isNaN(v) || v < 1) self.qtyInput.value = 1;
        });
        // Enter tuşu: sepete ekle (ödeme değil)
        this.qtyInput.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); self.addToCart(false); }
        });
      }

      this.updateOptionStates();
      if (current && current.mediaId && this.gallery && this.gallery.selectMedia) {
        // Başlangıç varyantının görseli ilk görsel değilse oraya git (animasyonsuz)
        setTimeout(function () { self.gallery.selectMedia(current.mediaId, true); }, 0);
      }

      this.initSticky();
      if (this.updateUrl) this.rememberViewed();
    }

    findById(id) {
      for (var i = 0; i < this.variants.length; i++) if (this.variants[i].id === id) return this.variants[i];
      return null;
    }

    getSelected() {
      var selected = [];
      this.querySelectorAll('[data-option-input]').forEach(function (el) {
        var pos = parseInt(el.dataset.optionPosition, 10) - 1;
        if (el.tagName === 'SELECT') selected[pos] = el.value;
        else if (el.checked) selected[pos] = el.value;
      });
      return selected;
    }

    matches(variant, options) {
      for (var i = 0; i < options.length; i++) {
        if (options[i] !== undefined && variant.options[i] !== options[i]) return false;
      }
      return true;
    }

    findVariant(options) {
      for (var i = 0; i < this.variants.length; i++) {
        if (this.matches(this.variants[i], options)) return this.variants[i];
      }
      return null;
    }

    // Var olmayan kombinasyonları devre dışı bırak, tükenenleri işaretle
    updateOptionStates() {
      var self = this;
      var selected = this.getSelected();
      this.querySelectorAll('[data-option-input]').forEach(function (el) {
        var pos = parseInt(el.dataset.optionPosition, 10) - 1;
        var targets = el.tagName === 'SELECT' ? Array.prototype.slice.call(el.options) : [el];
        targets.forEach(function (node) {
          var candidate = selected.slice();
          candidate[pos] = node.value;
          var exists = false;
          var anyAvailable = false;
          for (var i = 0; i < self.variants.length; i++) {
            if (self.matches(self.variants[i], candidate)) {
              exists = true;
              if (self.variants[i].available) { anyAvailable = true; break; }
            }
          }
          node.disabled = !exists;
          node.classList.toggle('is-soldout', exists && !anyAvailable);
          if (el.tagName === 'SELECT' && exists && !anyAvailable) node.dataset.soldout = 'true';
        });
      });
    }

    onOptionChange() {
      var selected = this.getSelected();
      var variant = this.findVariant(selected);
      this.updateOptionStates();
      this.querySelectorAll('.option').forEach(function (wrap) {
        var pos = parseInt(wrap.dataset.optionPosition, 10) - 1;
        var label = wrap.querySelector('[data-option-selected]');
        if (label) label.textContent = selected[pos] || '';
      });

      if (!variant) {
        this.renderUnavailable();
        return;
      }
      this.currentVariant = variant;
      this.render(variant);
    }

    setButtons(variant) {
      var available = !!(variant && variant.available);
      var text = variant ? (available ? S.addToCart : S.soldOut) : S.unavailable;
      if (this.addBtn) {
        this.addBtn.disabled = !available;
        var span = this.addBtn.querySelector('[data-add-text]');
        if (span) span.textContent = text;
      }
      if (this.buyNowBtn) this.buyNowBtn.disabled = !available;
      if (this.stickyBtn) {
        this.stickyBtn.disabled = !available;
        var st = this.stickyBtn.querySelector('[data-sticky-text]');
        if (st) st.textContent = text;
      }
    }

    renderUnavailable() {
      this.currentVariant = null;
      if (this.idInput) this.idInput.disabled = true;
      this.setButtons(null);
    }

    render(variant) {
      var self = this;

      if (this.idInput) {
        this.idInput.disabled = false;
        this.idInput.value = variant.id;
        // Shopify hızlı ödeme düğmeleri bu değişikliği dinler
        this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Fiyat
      var priceRoot = this.querySelector('.product__price [data-price-root]');
      if (priceRoot) {
        var cur = priceRoot.querySelector('[data-price]');
        var cmp = priceRoot.querySelector('[data-compare-price]');
        var off = priceRoot.querySelector('[data-discount]');
        var lbl = priceRoot.querySelector('[data-compare-label]');
        if (cur) cur.textContent = variant.price;
        if (cmp) { cmp.textContent = variant.onSale ? variant.compare : ''; cmp.hidden = !variant.onSale; }
        if (off) { off.textContent = variant.onSale ? variant.discount : ''; off.hidden = !variant.onSale; }
        if (lbl) lbl.hidden = !variant.onSale;
        priceRoot.classList.toggle('price--on-sale', !!variant.onSale);
        var unit = priceRoot.querySelector('[data-unit-price]');
        if (unit) unit.hidden = true; // varyanta özel birim fiyat sunucuda hesaplanır
      }

      // Stok
      var av = this.querySelector('[data-availability]');
      if (av) {
        var txt = av.querySelector('[data-availability-text]');
        var message;
        if (!variant.available) message = av.dataset.msgSoldOut;
        else if (variant.inventory > 0 && variant.inventory <= 5) message = (av.dataset.msgLow || '').replace('__COUNT__', variant.inventory);
        else message = av.dataset.msgInStock;
        if (txt) txt.textContent = message;
        av.classList.toggle('is-in-stock', variant.available);
        av.classList.toggle('is-sold-out', !variant.available);
      }

      // SKU
      var sku = this.querySelector('[data-sku]');
      if (sku) {
        sku.textContent = variant.sku || '';
        if (sku.parentElement) sku.parentElement.hidden = !variant.sku;
      }

      this.setButtons(variant);
      this.clearError();

      // URL
      if (this.updateUrl && window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }

      // Galeri
      if (variant.mediaId && this.gallery && this.gallery.selectMedia) this.gallery.selectMedia(variant.mediaId);

      // Sabit çubuk
      var sv = this.querySelector('[data-sticky-variant]');
      var sp = this.querySelector('[data-sticky-price]');
      if (sv) sv.textContent = variant.title;
      if (sp) sp.textContent = variant.price;

      this.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: variant } }));
      F.announce(variant.title + ', ' + variant.price + (variant.available ? '' : ', ' + S.soldOut));
    }

    showError(message) {
      var el = this.querySelector('[data-form-error]');
      if (!el) return;
      el.textContent = message;
      el.hidden = false;
    }
    clearError() {
      var el = this.querySelector('[data-form-error]');
      if (!el) return;
      el.textContent = '';
      el.hidden = true;
    }

    addToCart(buyNow) {
      var self = this;
      var variant = this.currentVariant;
      if (!variant || !variant.available) {
        this.showError(variant ? S.soldOut : S.unavailable);
        return;
      }
      var buttons = [this.addBtn, this.stickyBtn, buyNow ? this.buyNowBtn : null].filter(Boolean);
      if (buttons.some(function (b) { return b.classList.contains('is-loading'); })) return;

      this.clearError();
      buttons.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-disabled', 'true'); });

      var fd = new FormData(this.form);
      fd.set('id', variant.id);
      var qty = parseInt(fd.get('quantity'), 10);
      fd.set('quantity', isNaN(qty) || qty < 1 ? 1 : qty);

      F.Cart.add(fd).then(function () {
        if (buyNow) {
          window.location.href = '/checkout';
          return;
        }
        var modal = self.closest('quick-view-modal');
        if (modal) modal.close();
        F.Cart.afterAdd();
      }).catch(function (err) {
        var msg = (err && err.message) || S.cartError;
        self.showError(msg);
        F.toast(msg, 'error');
      }).then(function () {
        if (buyNow && !self.isConnected) return;
        buttons.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-disabled'); });
      });
    }

    // Mobil sabit satın alma çubuğu
    initSticky() {
      var self = this;
      if (!this.sticky || !this.addBtn || !('IntersectionObserver' in window)) return;
      var buyOut = false;
      var footerIn = false;
      var update = function () {
        var show = buyOut && !footerIn;
        self.sticky.classList.toggle('is-visible', show);
        self.sticky.inert = !show;
      };
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        buyOut = !e.isIntersecting && e.boundingClientRect.top < 0;
        update();
      }).observe(this.addBtn);

      var footer = document.querySelector('.footer');
      if (footer) {
        new IntersectionObserver(function (entries) {
          footerIn = entries[0].isIntersecting;
          update();
        }).observe(footer);
      }
    }

    // "Son incelenen ürünler" için gezinme geçmişi (yalnızca bu tarayıcıda)
    rememberViewed() {
      try {
        var handle = this.dataset.handle;
        if (!handle) return;
        var list = JSON.parse(localStorage.getItem('f365_recent') || '[]');
        list = list.filter(function (h) { return h !== handle; });
        list.unshift(handle);
        localStorage.setItem('f365_recent', JSON.stringify(list.slice(0, 16)));
      } catch (e) { /* localStorage kapalı olabilir */ }
    }
  }
  customElements.define('product-info', ProductInfo);

  // Kargo geri sayımı (Türkiye saati, UTC+3)
  class ShippingCountdown extends HTMLElement {
    connectedCallback() {
      this.cut = {
        1: this.parse(this.dataset.weekday), 2: this.parse(this.dataset.weekday), 3: this.parse(this.dataset.weekday),
        4: this.parse(this.dataset.weekday), 5: this.parse(this.dataset.weekday),
        6: this.parse(this.dataset.saturday), 0: this.parse(this.dataset.sunday)
      };
      this.holidays = (this.dataset.holidays || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
      this.titleEl = this.querySelector('[data-cd-title]');
      this.textEl = this.querySelector('[data-cd-text]');
      this.timerEl = this.querySelector('[data-cd-timer]');
      this.tick();
      var self = this;
      this.timer = setInterval(function () { self.tick(); }, 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    parse(v) {
      var m = /^(\d{1,2})[:.](\d{2})$/.exec((v || '').trim());
      return m ? { h: parseInt(m[1], 10), m: parseInt(m[2], 10), label: ('0' + m[1]).slice(-2) + ':' + m[2] } : null;
    }
    istanbulNow() {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Istanbul', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).formatToParts(new Date());
      var o = {}; parts.forEach(function (p) { o[p.type] = parseInt(p.value, 10); });
      return Date.UTC(o.year, o.month - 1, o.day, o.hour, o.minute, o.second);
    }
    iso(d) { return d.toISOString().slice(0, 10); }
    tick() {
      var nowMs = this.istanbulNow(), now = new Date(nowMs);
      var day0 = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
      var found = null;
      for (var i = 0; i < 14 && !found; i++) {
        var d = new Date(day0.getTime() + i * 86400000), c = this.cut[d.getUTCDay()];
        if (!c || this.holidays.indexOf(this.iso(d)) > -1) continue;
        var at = d.getTime() + (c.h * 3600 + c.m * 60) * 1000;
        if (at > nowMs) found = { offset: i, at: at, label: c.label, date: d };
      }
      if (!found) { this.hidden = true; return; }
      var D = this.dataset, same = found.offset === 0, dayName;
      if (found.offset === 1) dayName = D.tTomorrow;
      else dayName = new Intl.DateTimeFormat('tr-TR', { weekday: 'long', timeZone: 'UTC' }).format(found.date);
      dayName = dayName.charAt(0).toLocaleUpperCase('tr-TR') + dayName.slice(1);
      this.titleEl.textContent = same ? D.tTodayTitle : D.tNextTitle.replace('__DAY__', dayName);
      this.textEl.textContent = same ? D.tTodayText.replace('__TIME__', found.label) : D.tNextText.replace('__DAY__', dayName.toLocaleLowerCase('tr-TR'));
      this.classList.toggle('is-today', same);
      var left = Math.max(0, Math.floor((found.at - nowMs) / 1000));
      var dd = Math.floor(left / 86400), hh = Math.floor(left % 86400 / 3600), mm = Math.floor(left % 3600 / 60), ss = left % 60;
      var cell = function (v, u) { return '<span class="ship-cd__cell"><b>' + ('0' + v).slice(-2) + '</b><i>' + u + '</i></span>'; };
      this.timerEl.innerHTML = (dd > 0 ? cell(dd, D.tD) : '') + cell(hh, D.tH) + cell(mm, D.tM) + cell(ss, D.tS);
      this.hidden = false;
    }
  }
  customElements.define('shipping-countdown', ShippingCountdown);

  // Taksit penceresi: tutarlar seçili varyantın fiyatından hesaplanır
  class InstallmentInfo extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.dialog = this.querySelector('dialog');
      this.cents = parseInt(this.getAttribute('data-price'), 10) || 0;
      this.currency = this.getAttribute('data-currency') || 'TRY';
      this.render();
      this.querySelector('[data-inst-open]').addEventListener('click', function () {
        if (self.dialog.showModal) self.dialog.showModal(); else self.dialog.setAttribute('open', '');
        if (F.lockScroll) F.lockScroll();
      });
      this.querySelectorAll('[data-inst-close]').forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
      this.dialog.addEventListener('click', function (e) { if (e.target === self.dialog) self.close(); });
      this.dialog.addEventListener('close', function () { if (F.unlockScroll) F.unlockScroll(); });
      var info = this.closest('product-info');
      if (info) info.addEventListener('variant:change', function (e) {
        var v = e.detail && e.detail.variant;
        if (v && typeof v.cents === 'number') { self.cents = v.cents; self.render(); }
        var p = self.querySelector('[data-inst-price]'); if (p && v) p.textContent = v.price;
      });
    }
    close() { if (this.dialog.close) this.dialog.close(); else this.dialog.removeAttribute('open'); }
    money(value) {
      if (this.currency === 'TRY') return value.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
      try { return value.toLocaleString(document.documentElement.lang || undefined, { style: 'currency', currency: this.currency }); }
      catch (e) { return value.toFixed(2); }
    }
    render() {
      var self = this, price = this.cents / 100;
      this.querySelectorAll('tr[data-fast]').forEach(function (tr) {
        var disc = parseFloat(tr.getAttribute('data-fast')) || 0;
        var v = Math.round(price * (1 - disc / 100) * 100) / 100;
        tr.querySelector('[data-monthly]').textContent = self.money(v);
        tr.querySelector('[data-total]').textContent = self.money(v);
      });
      this.querySelectorAll('tr[data-n]').forEach(function (tr) {
        var n = parseInt(tr.getAttribute('data-n'), 10), rate = parseFloat(tr.getAttribute('data-rate')) || 0;
        var total = Math.round(price * (1 + rate / 100) * 100) / 100;
        tr.querySelector('[data-monthly]').textContent = self.money(total / n);
        tr.querySelector('[data-total]').textContent = self.money(total);
      });
    }
  }
  customElements.define('installment-info', InstallmentInfo);

  // Ürün sayfasındaki ücretsiz kargo çubuğu: sepet değişince sunucudan taze render alır
  (function () {
    var busy = false;
    function refreshShippingBar() {
      var holder = document.querySelector('[data-pdp-shipping]');
      var section = holder && holder.closest('[id^="shopify-section-"]');
      if (!holder || !section || busy) return;
      busy = true;
      var id = section.id.replace('shopify-section-', '');
      fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.querySelector('[data-pdp-shipping]');
          if (!next) return;
          var oldBar = holder.querySelector('[data-free-shipping]');
          var prev = oldBar ? oldBar.getAttribute('data-percent') : null;
          holder.innerHTML = next.innerHTML;
          var bar = holder.querySelector('[data-free-shipping]');
          var fill = bar && bar.querySelector('.fs-bar__fill');
          var target = bar && bar.getAttribute('data-percent');
          if (fill && prev !== null && prev !== target && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            fill.style.width = prev + '%';
            requestAnimationFrame(function () { requestAnimationFrame(function () { fill.style.width = target + '%'; }); });
          }
        })
        .catch(function () {})
        .then(function () { busy = false; });
    }
    document.addEventListener('cart:updated', refreshShippingBar);
    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshShippingBar(); });
  })();

  /* ======================================================================
     Hızlı ürün inceleme
     ====================================================================== */

  class QuickViewModal extends window.OverlayElement {
    connectedCallback() {
      var self = this;
      this.content = this.querySelector('[data-quick-view-content]');
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-quick-view][data-url]');
        if (!btn) return;
        e.preventDefault();
        self.load(btn);
      });
      this.addEventListener('overlay:close', function () {
        setTimeout(function () { if (!self.isOpen) self.content.innerHTML = ''; }, 400);
      });
    }

    load(btn) {
      var self = this;
      if (btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      var url = btn.dataset.url;
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'view=quick', { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('quick view');
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var node = doc.querySelector('.quick-view');
          if (!node) throw new Error('quick view');
          self.content.innerHTML = node.innerHTML;
          self.open(btn);
        })
        .catch(function () {
          window.location.href = url; // olmazsa ürün sayfasına git
        })
        .then(function () { btn.classList.remove('is-loading'); });
    }
  }
  customElements.define('quick-view-modal', QuickViewModal);

  /* ======================================================================
     Ürün önerileri (Shopify Recommendations API)
     ====================================================================== */

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      var self = this;
      if (this.querySelector('.section')) return; // zaten render edilmiş
      var load = function () {
        fetch(self.dataset.url, { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (text) {
            if (!text) return;
            var doc = new DOMParser().parseFromString(text, 'text/html');
            var rec = doc.querySelector('product-recommendations');
            if (rec && rec.innerHTML.trim()) {
              self.innerHTML = rec.innerHTML;
              F.initReveal(self);
            }
          })
          .catch(function () { /* öneri yoksa bölüm boş kalır */ });
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { io.disconnect(); load(); }
        }, { rootMargin: '500px 0px' });
        io.observe(this);
      } else {
        load();
      }
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  /* ======================================================================
     Son incelenen ürünler
     ====================================================================== */

  class RecentlyViewed extends HTMLElement {
    connectedCallback() {
      var self = this;
      var list;
      try { list = JSON.parse(localStorage.getItem('f365_recent') || '[]'); } catch (e) { return; }
      var limit = parseInt(this.dataset.limit, 10) || 4;
      var current = this.dataset.current;
      list = list.filter(function (h) { return h && h !== current; }).slice(0, limit);
      if (!list.length) return;

      var root = (T.routes && T.routes.root) || '/';
      var target = this.querySelector('[data-recent-list]');

      Promise.all(list.map(function (handle) {
        return fetch(root + 'products/' + encodeURIComponent(handle) + '?view=card', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      })).then(function (cards) {
        var count = 0;
        cards.forEach(function (html) {
          if (html && html.indexOf('product-card') > -1) {
            var li = document.createElement('li');
            li.className = 'product-grid__item';
            li.innerHTML = html;
            target.appendChild(li);
            count++;
          }
        });
        if (count) self.hidden = false;
      });
    }
  }
  customElements.define('recently-viewed', RecentlyViewed);
})();
